import { TransactionModel } from 'src/types/transaction.model';
import { createContext, useContext, useEffect, useState } from 'react';
import { TransactionRowModel } from 'src/components/atomic/organisms/transaction/TransactionsTable';

export interface SelectedTransactionsContextValues {
    setAllTransactionsSelect: (checked: boolean) => void;
}

export const SelectedTransactionsContext = createContext<SelectedTransactionsContextValues>({
    setAllTransactionsSelect: () => {}
});

export const useSelectedTransactionsContext = (): SelectedTransactionsContextValues => {
    return useContext(SelectedTransactionsContext);
};

export const useTransactionRows = (
    transactions: TransactionModel[]
): {
    transactionRows: TransactionRowModel[];
    setTransactionRows: (transactionRows: TransactionRowModel[]) => void;
    selectedTransactions: TransactionModel[];
    setAllTransactionsSelect: (checked: boolean) => void;
    showBanner: boolean;
} => {
    const [showBanner, setShowBanner] = useState<boolean>(false);
    const [transactionRows, setTransactionRows] = useState<TransactionRowModel[]>([]);
    const selectedTransactions: TransactionModel[] = transactionRows
        ?.filter((e) => e.checked)
        .map((e) => e.transaction);

    /** HOOKS */
    // Show the banner when transactions are selected
    useEffect(() => {
        if (selectedTransactions.length > 0) setShowBanner(true);
        else setShowBanner(false);
    }, [selectedTransactions]);

    // Set the transaction rows when the filtered transactions change
    useEffect(() => {
        if (transactions) {
            const newTransactionRows: TransactionRowModel[] = transactions.map((transaction) => {
                const existingRow = transactionRows.find((row) => row.transaction.id === transaction.id);
                return { transaction, checked: existingRow?.checked || false };
            });
            setTransactionRows(newTransactionRows);
        }
    }, [transactions]);

    const setAllTransactionsSelect = (checked: boolean): void => {
        setTransactionRows(
            transactionRows.map((e) => {
                return { ...e, checked };
            })
        );
    };

    return {
        transactionRows,
        setTransactionRows,
        setAllTransactionsSelect,
        selectedTransactions,
        showBanner
    };
};
